import { useTranslation } from "react-i18next";
import { Contact } from "@/components/site/Contact";
import { StandalonePageShell } from "@/components/site/StandalonePageShell";
import { useSiteContent } from "@/lib/useSiteContent";

export default function ContactPage() {
  const { t } = useTranslation();
  const home = useSiteContent("home");
  const contact = useSiteContent("contact");
  const dealers = useSiteContent("dealers");

  return (
    <StandalonePageShell
      content={{ home, contact, dealers }}
      eyebrow={contact.eyebrow || t("pages.contact.eyebrow")}
      title={contact.title || t("pages.contact.title")}
      description={contact.description || t("pages.contact.description")}
    >
      <div data-testid="contact-page"><Contact content={contact} /></div>
    </StandalonePageShell>
  );
}
